module.exports = __webpack_public_path__ + "images/marketing/pipelinedeals_logo_stacked.png";